import RouteView from "@/layouts/RouteView.vue";
export default {
  path: "/groupRoom",
  name: "groupCentralOrder",
  redirect: "/groupRoom/CentralOrder",
  component: RouteView,
  meta: {
    title: "中央预订",
    isGroup: true,
    icon: "shop-collect-o",
    showNavBar: true,
  },
  children: [
    {
      path: "/groupRoom/CentralOrder",
      name: "groupCentralOrder",
      component: () => import("@/views/groupRoom/CentralOrder.vue"),
      meta: {
        title: "中央预订",
        isGroup: true,
        showNavBar: true,
      },
    },
    {
      path: "/groupRoom/CentralOrderDetail",
      name: "groupCentralOrderDetail",
      component: () => import("@/views/groupRoom/CentralOrderDetail.vue"),
      meta: {
        title: "预定详情",
        isGroup: true,
        showNavBar: false,
      },
    },
    {
      path: "/groupRoom/RoomOrder",
      name: "groupRoomOrder",
      component: () => import("@/views/groupRoom/RoomOrder.vue"),
      meta: {
        title: "入住/预定",
        isGroup: true,
        // showNavBar: false
      },
    },
    {
      path: "/groupRoom/RoomForecast",
      name: "groupRoomForecast",
      component: () => import("@/views/groupRoom/RoomForecast.vue"),
      meta: {
        title: "房情预测",
        isGroup: true,
        showNavBar: true,
      },
    },
    {
      path: "/groupRoom/RoomForecastDetail",
      name: "groupRoomForecastDetail",
      component: () => import("@/views/groupRoom/RoomForecastDetail.vue"),
      meta: {
        title: "房情预测详情",
        isGroup: true,
        showNavBar: false,
      },
    },
  ],
};
